import * as React from 'react';

// PACKAGES
import { useHistory } from 'react-router';

// COMPONENTS
import Button from '../../components/Button';

// ICONS
import { ReactComponent as TickSuccessIcon } from '../../assets/svg/tick-purple.svg';

interface LinkSuccessTypes {}

const LinkSuccess: React.FC<LinkSuccessTypes> = ({}) => {
	const history = useHistory();
	return (
		<div className="link-success row">
			<div className="link-container col-md-4">
				<TickSuccessIcon />

				<h1>Your selection is complete</h1>

				<Button onClick={() => history.push('/dashboard')} className="btn-primary">
					Continue to dashboard
				</Button>
			</div>
		</div>
	);
};

export default LinkSuccess;
